export default {"src":"/_next/static/media/yelow_heart_filled.b6db2ef6.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};